import "@hotwired/turbo-rails"

Turbo.session.drive = false
Turbo.setFormMode("optin")
Turbo.StreamActions.redirect = function () {
  window.location = this.target;
};

document.addEventListener("DOMContentLoaded", function (event) {
  document.querySelector("#toggle-mobile-menu").addEventListener("click", () => {
    document.querySelectorAll(".header-menu").forEach(i => { i.classList.toggle("hidden") })
  })
})
